import proxy from "../proxy";
const qr = {
  list:
    (data = {}) =>
    async (dispatch) =>
      await proxy.get("qr/list", data, { dispatch }),
  info:
    (data = {}) =>
    async (dispatch) => {
      await proxy.get("qr/info", data, { dispatch });
    },
  add:
    (data = {}, data2 = {}) =>
    async (dispatch) => {
      await proxy.post("qr/add", data);
      await proxy.get("qr/list", data2, { dispatch });
    },
  del:
    (data = {}, data2 = {}) =>
    async (dispatch) => {
      await proxy.delete("ar/delete", data);
      await proxy.get("ar/list", data2, { dispatch });
    },
  update:
    (data = {}, data2 = {}) =>
    async (dispatch) => {
      await proxy.put("ar/update", data);
      await proxy.get("ar/list", data2, { dispatch });
    },
};

export default qr;
